import { render, staticRenderFns } from "./HeaderXs.vue?vue&type=template&id=6aaf855b&scoped=true&"
import script from "./HeaderXs.vue?vue&type=script&lang=js&"
export * from "./HeaderXs.vue?vue&type=script&lang=js&"
import style0 from "./HeaderXs.vue?vue&type=style&index=0&id=6aaf855b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaf855b",
  null
  
)

export default component.exports